import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export type OpenDialogAttrs = {
  scope?: string | null;
  part?: string | null;
  state?: string | null;
  role?: string | null;
};

/**
 * An open Chakra/Zag dialog content node. Closed dialogs stay in the DOM with
 * `data-state="closed"` when they are not unmounted, so state has to be open.
 * Kept in sync with `OPEN_DIALOG_SELECTOR`.
 */
export function isOpenDialog(attrs: OpenDialogAttrs) {
  if (attrs.state !== 'open') {
    return false;
  }
  if (attrs.scope === 'dialog' && attrs.part === 'content') {
    return true;
  }
  return attrs.role === 'dialog' || attrs.role === 'alertdialog';
}
export const OPEN_DIALOG_SELECTOR = ['[data-scope="dialog"][data-part="content"][data-state="open"]', '[role="dialog"][data-state="open"]', '[role="alertdialog"][data-state="open"]'].join(', ');
export function hasOpenDialog(root: ParentNode) {
  return root.querySelector(OPEN_DIALOG_SELECTOR) != null;
}

/** True while any Chakra dialog content is open. */
export function useOpenDialog() {
  const $ = _c(2);
  const [open, setOpen] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const sync = () => setOpen(hasOpenDialog(document));
      sync();
      const observer = new MutationObserver(sync);
      observer.observe(document.body, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["data-state", "role", "data-scope", "data-part"]
      });
      return () => observer.disconnect();
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return open;
}